<template>
    <b-modal 
    hide-footer
    :visible="isModalDetailFilesShow"
    @change="(val) => $emit('update:is-modal-detail-files-show', val)"
    @shown="getData(itemData)"
    >
        <template #modal-title>
            File Detail 
        </template>
       <div class="p-2">
        <b-form-group
                label="Name"
                label-for="name"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm="7"
                content-cols-lg="7"
                        
              >
              <div style="margin-top: 5px;">{{  Data.name }}</div>
        </b-form-group>
        <b-form-group
                label="Path"
                label-for="path"
           
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm="7"
                content-cols-lg="7"
                class="text-break"
              >
              <span>{{  Data.fullpath }}</span>
        </b-form-group>
        <b-form-group
                label="File Size"
                label-for="size"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm="7"
                content-cols-lg="7"
              >
              <span>{{  Data.filesize }}Kb</span>
        </b-form-group>

       </div>
        
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
        <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
          <validation-provider
              #default="validationContext"
              name="alt_attribute"
              rules="min:0"
            >
              <b-form-group
                label="Alt Attribute"
                label-for="alt_attribute"
              >
                <b-form-input
                  id="alt_attribute"
                  v-model="Data.alt_attribute"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Alt Attribute"
               
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="description"
              rules="min:0"
            >
              <b-form-group
                label="Description"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="Data.description"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Description"
               
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="closeModal"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
       


    </b-modal>
</template>
<script>
import { BButton, BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
//validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
//api
import store from '@/store'
import { ref } from '@vue/composition-api'
//alerty
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
    model: {
        prop: 'isModalDetailFilesShow',
        event: 'update:is-modal-detail-files-show',
    },
    props: {
        isModalDetailFilesShow: {
          type: Boolean,
          required: true,
        },
        itemData:{
          type: Object,
          required:true
        }
     
      
    },
 components: {
    BButton,
    BModal,
    BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }){
    const toast = useToast()
    const blankData = {
      
      title: '',
    
   
    }
    const Data = ref(JSON.parse(JSON.stringify(blankData)))
    const getData = (item)=>{
      if(item){
        Data.value = item;
      }
       
    }
    const onSubmit = async() => {
         let title =  Data.value.title.replace(/[`~%^&*!@#$()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
          let slug = title.toLowerCase().replace(/\s+/g, '-');
          Data.value.slug = slug;
          let res = await store.dispatch('app-files/updateData',Data.value);
          if(res.data.success){
            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${res.data.message}`,
                },
            });

          }else{
            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${res.data.message}`,
                },
            });

          }
        //  console.log('res',res);
          //updateData
        emit('refetch-data')
        emit('update:is-modal-detail-files-show', false)
    }
    const resetData = () => {
        //Data.value = JSON.parse(JSON.stringify(blankData))
    }
    const closeModal = ()=>{
        emit('update:is-modal-detail-files-show', false)
    }
    const {
        refFormObserver,
        getValidationState,
        resetForm,
      } = formValidation(resetData)
    return {
        refFormObserver,
        getValidationState,
        resetForm,
        getData,
        onSubmit,
        resetData,
        closeModal,
        Data
    }

  }
    
}
</script>